import { Box } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MyTrans } from '@halo/ui-react';
import { useStaticAppStore } from '@/store/client';
import { useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

export interface MsgLuckyBoxClaimedContentProps {
  message: Msg;
}

export const MsgLuckyBoxClaimedContent = memo(function MsgLuckyBoxClaimedContent({
  message,
}: MsgLuckyBoxClaimedContentProps) {
  const { t } = useTranslation();
  const { grab_user_id, sender_id } = message.payload;
  const { user: currentUser } = useStaticAppStore();
  const { user: grabUser } = useUserInfo(grab_user_id);
  const { user: sendUser } = useUserInfo(sender_id);
  const isMe = sender_id === currentUser?.user_id;
  const cssProps = useMemo(
    () => (isMe ? { color: 'fg.muted', cursor: 'default', pointerEvents: 'none' as const } : {}),
    [isMe]
  );

  return (
    <MyTrans
      i18nKey="chat.groupMessageLuckyBoxClaimedText"
      components={{
        grabUser: <MsgUserText userName={grabUser?.name || ''} userId={grab_user_id} />,
        action: <Box as="span" color="fg.muted" />,
        sendUser: (
          <MsgUserText
            userName={isMe ? t('chat.your') : sendUser?.name || ''}
            userId={sender_id}
            px="1"
            {...cssProps}
          />
        ),
        luckyBox: <Box as="span">{t('chat.luckyBoxText')}</Box>,
      }}
    ></MyTrans>
  );
});
